<template>
  <div class="flex gap-6">
    <div
      class="card-holder"
      :class="{ inactive: isInactive, isDisabled: !hasInventory }"
    >
      <div
        class="inner-card-holder"
        @click="handleSelection"
        :class="{ active: isSelected }"
      >
        <!-- Check Box Here -->
        <label class="checkbox-container">
          <input
            type="checkbox"
            @change="handleSelection"
            :checked="isSelected"
          />
          <!-- <span class="checkmark"></span> -->
        </label>
        <!-- Image Here -->
        <div v-if="isHEIC" class="image-holder" id="target">
          <span v-if="imageUrl === null"> Loading... </span>
          <span v-else>
            <img
              :src="imageUrl"
              alt="image"
              @error="handleBrokenImage($event)"
            />
          </span>
        </div>
        <div v-else class="image-holder">
          <img
            :src="product.image"
            alt="image"
            @error="handleBrokenImage($event)"
          />
        </div>
      </div>

      <!-- Product Details Here -->
      <div class="product-details">
        <p class="name">{{ product.name | capitalize }}</p>
        <p v-if="product.price">${{ product.price }}</p>
      </div>

      <!-- Ellipsis Here -->
      <div class="ellipsis" v-if="isSelected && product.itemableAttributes">
        <span>{{
          getSelectedVarient(
            product.id,
            isSelected && product.itemableAttributes.product_variants.length > 1
          )
        }}</span>
        <span
          class="edit"
          v-if="
            isSelected && product.itemableAttributes.product_variants.length > 1
          "
          @click="handleModal"
          >Edit</span
        >
      </div>
    </div>
    <!-- Modal Here -->
    <section v-if="isOpen">
      <Modal
        color-variation="abstract"
        :show-footer="false"
        :showXButton="false"
        :custom-styles="{ width: '777px' }"
        :isSelectOpen="isSelectOpen"
      >
        <template #header>
          <h2 class="editorial">
            {{ product.name | capitalize }}
          </h2>
        </template>

        <template #body>
          <section v-if="product.origin == 'projects'">
            <Singleproduct
              :product="product"
              :selectedItems="selected"
              @updateSelection="updateSelection"
              @persistData="persistData"
              @isSelectOpen="value => (isSelectOpen = value)"
            />
          </section>

          <section v-else>
            <RedemptionSingleProduct
              v-if="product.type == 'product'"
              :product="product"
              :selectedItems="selected"
              :payload="selected"
              @updateProductVariant="
                data => $emit('updateProductVariant', data)
              "
              @updateSelection="updateSelection"
              @persistData="closeModal"
              @isSelectOpen="value => (isSelectOpen = value)"
            />

            <RedemptionBundle
              v-else
              :product="product"
              :data="bundleData"
              :payload="selected"
              @updateProductVariant="
                data => $emit('updateProductVariant', data)
              "
              @persistData="closeModal"
              @isSelectOpen="value => (isSelectOpen = value)"
            />
          </section>
        </template>
      </Modal>
    </section>
  </div>
</template>

<script>
import { handleBrokenImage, defaultNotFoundImage } from '@/helpers'
import Modal from '../Modal'
import Singleproduct from './Singleproduct'
import RedemptionSingleProduct from './RedemptionSingleProduct'
import RedemptionBundle from './RedemptionBundle'
import HEICConversion from '../../../mixins/HEICConversion'
export default {
  name: 'ProductCard',
  mixins: [HEICConversion],
  components: {
    Modal,
    Singleproduct,
    RedemptionSingleProduct,
    RedemptionBundle
  },

  props: {
    limit: {
      type: Number,
      default: null
    },
    isAddressCollection: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      default: () => ({})
    },
    selected: {
      type: Array,
      default: () => []
    },
    bundleData: {
      type: Object,
      default: () => ({})
    },
    tier: {
      type: Object,
      default: () => ({})
    }
  },

  data: () => ({
    isOpen: false,
    isSelectOpen: false,
    handleBrokenImage: handleBrokenImage
  }),

  computed: {
    isSelected() {
      return !!this.selected.find(item => item.id === this.product.id)
    },
    hasInventory() {
      if (this.product.type === 'product') {
        let options = this.getVariantOptions(this.product)
        if (options) {
          if (options.length === 1) {
            return options[0].hasInventory
          } else {
            return true
          }
        } else {
          return false
        }
      } else {
        return true
      }
    },

    isInactive() {
      if (this.tier) {
        const selectedInThisTier = this.selected.filter(
          item => parseInt(item.tierId) === parseInt(this.tier.id)
        )

        if (this.tier.selectionType && this.tier.selectionType === 'UPTO') {
          // users can select up to any limit so the product card
          //  should not be disabled after limit is reached
          return false
        }
        return selectedInThisTier.length === this.limit && !this.isSelected
      }
      return this.selected.length === this.limit && !this.isSelected
    }
  },
  mounted() {
    this.checkHEIC(this.product.image, this.product.fileType)
  },
  methods: {
    handleSelection() {
      if (this.isAddressCollection) {
        this.handleAddressCollection()
      } else {
        this.handleRedemption()
      }
    },

    handleAddressCollection() {
      const { option } = this.product
      const transformed = Object.values(option.length ? option[0] : {})
      const optionLength = transformed.length ? transformed[0].length : 0

      this.$emit('handleSelectedItem', this.product)

      if (this.isAddressCollection && optionLength === 1) return
      else {
        setTimeout(() => {
          this.handleModal(option)
        }, 300)
      }
    },
    handleRedemption() {
      let { type } = this.product
      if (type === 'product') {
        let options = this.getVariantOptions(this.product)
        options.length > 1 ? this.handleTimeOut(300, this.product) : null

        const defaultSeletedVariant = options[0]
        if (
          options.length > 1 ||
          (options.length === 1 && options[0].hasInventory)
        ) {
          this.$emit('handleSelectedItem', this.product)
          // select varaint
          this.$emit('updateProductVariant', {
            itemId: this.product.itemId,
            ...defaultSeletedVariant
          })
        }
      } else {
        this.$emit('handleSelectedItem', this.product)
        this.handleTimeOut(300, this.product)
      }
    },

    handleTimeOut(timeout, option) {
      setTimeout(() => {
        this.handleModal(option)
      }, timeout)
    },

    handleModal(option) {
      if (!this.isSelected) return
      if (option.length !== 0) this.isOpen = true
    },

    closeModal() {
      this.isOpen = false
    },

    updateSelection({ id, option, value }) {
      this.$emit('updateSelection', id, option, value)
    },

    persistData() {
      localStorage.setItem(
        'adminOrderSelectedItems',
        JSON.stringify(this.selected)
      )
      this.closeModal()
    },

    getVariantOptions(product) {
      let options = []

      const availableProduct =
        product.itemableAttributes &&
        product.itemableAttributes.product_variants_list &&
        product.itemableAttributes.product_variants_list.data

      if (availableProduct && availableProduct.length) {
        for (let index = 0; index < availableProduct.length; index++) {
          const variant = availableProduct[index].attributes

          options.push({
            code: parseInt(availableProduct[index].id),
            label: variant.name.toUpperCase(),
            hasInventory: variant.availableInventoryCount > 0,
            image: variant.images.length
              ? variant.images[0].url
              : defaultNotFoundImage
          })
        }

        return options.filter(option => option.hasInventory)
      }
    },
    checkOptionsCount(option) {
      if (option.length > 0) {
        const key = Object.keys(option[0])
        const count = option[0][key].length
        return count
      } else {
        return 0
      }
    },
    // eslint-disable-next-line no-unused-vars
    getSelectedVarient(id, isEditEnabled) {
      if (!this.$parent.selectedData) return
      const selectedVaritent = this.$parent.selectedData[id]
      if (selectedVaritent !== null) {
        if (isEditEnabled) {
          return `${selectedVaritent.label} `
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

h2 {
  font-weight: 400;
  font-size: 2rem;
  color: #25282a;
}

.card-holder {
  width: 270px;
  height: 296px;

  .inner-card-holder {
    height: 100%;
    width: 100%;
    cursor: pointer;
    border: 1px solid #a09c95;
    padding: 1.25rem;
    transition: border 0.4s ease;

    &.active {
      border: 2px solid #232220;
    }

    .image-holder {
      margin-top: 1.25rem;
      height: 194px;
      margin-top: 2rem;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
  .product-details {
    margin-top: 1rem;
    display: flex;
    align-items: center;

    p {
      text-align: left;
      color: #232220;
      font-size: 0.875rem;
      font-family: $inter;
    }

    .name {
      width: 180px;
      margin-right: auto;
      font-size: 1.1rem;
    }
  }

  .ellipsis {
    text-align: left;
    transition: all 0.4s ease;
    font-size: 0.75rem;
    .edit {
      font-size: 0.75rem;
      cursor: pointer;
      font-weight: 800;
      text-decoration: underline;
    }
  }
}

.inactive {
  opacity: 0.6;
}
.isDisabled {
  opacity: 0.6;
  cursor: not-allowed !important;
}

@media (max-width: 575.98px) {
  h2 {
    font-size: 1.5rem;
    line-height: 36px !important;
  }
}

@media (min-width: 576px) and (max-width: 767.98px) {
  h2 {
    font-size: 1.5rem;
    line-height: 36px !important;
  }
}
</style>
